import {
  GRETA_AI_CHAT_COMPOSER_PLACEHOLDER_KEY,
  GRETA_AI_CHAT_EMPTY_STATE_SUBTITLE_KEY,
  GRETA_AI_CHAT_FINANCE_NOT_BOUGHT_TEXT_KEY,
  GRETA_AI_CHAT_SOURCE_SUGGESTED_PROMPTS,
  GRETA_AI_CHAT_SOURCE_TEXT_KEYS,
  GRETA_AI_CHAT_SUGGESTED_PROMPTS,
} from './GretaAIChat.constants'
import {
  getGretaAIChatVisibleSuggestedPrompts,
  getIsGretaAIChatRowNewReply,
} from './GretaAIChat.utils'
import { getIsGretaAIChatFinanceSource } from './GretaAIChat.utils.source'

function getGretaAIChatLauncherUnreadTooltip(t, unreadSources) {
  return unreadSources.length === 1
    ? t('Greta.LauncherNewReplySourceKey', {
        name: t(GRETA_AI_CHAT_SOURCE_TEXT_KEYS[unreadSources[0]].shortKey),
      })
    : t('Greta.LauncherNewReplyKey')
}

export function getGretaAIChatSourcePlaceholderKey({
  isFinancePreview,
  isSourceChoiceEnabled,
  isSourceRevoked,
  source,
}) {
  if (isSourceRevoked) {
    return 'Greta.FinanceRevokedComposerPlaceholderKey'
  }

  if (isFinancePreview) {
    return GRETA_AI_CHAT_FINANCE_NOT_BOUGHT_TEXT_KEY
  }

  return isSourceChoiceEnabled || getIsGretaAIChatFinanceSource(source)
    ? GRETA_AI_CHAT_SOURCE_TEXT_KEYS[source].placeholderKey
    : GRETA_AI_CHAT_COMPOSER_PLACEHOLDER_KEY
}

export function getGretaAIChatSuggestedPrompts({
  isSourceChoiceEnabled,
  source,
}) {
  return isSourceChoiceEnabled
    ? GRETA_AI_CHAT_SOURCE_SUGGESTED_PROMPTS[source]
    : getGretaAIChatVisibleSuggestedPrompts(GRETA_AI_CHAT_SUGGESTED_PROMPTS)
}

export function getGretaAIChatUnreadSources(chatStatusById, chats) {
  const unreadChats = chats.filter(chat =>
    getIsGretaAIChatRowNewReply(chatStatusById[chat.id])
  )

  return [...new Set(unreadChats.map(chat => chat.source))]
}

export function getIsGretaAIChatFinanceOnlyUnread(unreadSources) {
  return (
    unreadSources.length === 1 &&
    getIsGretaAIChatFinanceSource(unreadSources[0])
  )
}

export function getGretaAIChatLauncherTooltip({
  hasUnread,
  isSourceChoiceEnabled,
  t,
  unreadSources,
}) {
  return isSourceChoiceEnabled && hasUnread
    ? getGretaAIChatLauncherUnreadTooltip(t, unreadSources)
    : null
}

export function getGretaAIChatEmptyStateSubtitleKey(isSourceChoiceEnabled) {
  return isSourceChoiceEnabled
    ? 'Greta.SourcePickerQuestionKey'
    : GRETA_AI_CHAT_EMPTY_STATE_SUBTITLE_KEY
}
